import { reactive } from 'vue'

export const backSwipeState = reactive({
  isDisabled: false
})
